import Vue from 'vue'
import Vuex from 'vuex'
import repositories from '@/repositories/RepositoryFactory'
import {
  SET_SERVICE_STATUS,
  SET_ACCOUNT,
  SET_COMPANIES,
  SET_ANNOUNCEMENT,
} from '@/const/mutation-types'
import { LOAD_BASIC_MASTERS } from '@/const/action-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // サービス稼働状態
    service: {
      available: false,
      message: undefined,
    },
    // アカウント情報
    account: {
      userId: undefined,
      roles: [],
    },
    // 企業マスタ（ログインユーザーが参照可能な企業のみ）
    companies: [],
    // 分類階層マスタ（ログインユーザーが参照可能な企業毎の階層すべて）
    // Storeに入れるにはアレですが、、企業コードをキーに階層配列を保存します。
    // {
    //   cyberlinks: [ ...levels ],
    // }
    // お知らせ
    announcement: {
      hasUnread: false,
    },
  },
  getters: {
    /**
     * ログインユーザーが管理者権限を持つか
     */
    isAdmin: state => {
      if (!state.account.roles) {
        return false
      }
      return state.account.roles.includes('admin')
    },
  },
  mutations: {
    [SET_SERVICE_STATUS](state, { available, message }) {
      state.service.available = available
      state.service.message = message
    },
    [SET_ACCOUNT](state, { userId, companyCode, loginId, roles }) {
      state.account.userId = userId
      state.account.companyCode = companyCode
      state.account.loginId = loginId
      state.account.roles = roles
    },
    [SET_COMPANIES](state, companies) {
      state.companies = companies
    },
    [SET_ANNOUNCEMENT](state, { hasUnread }) {
      state.announcement.hasUnread = hasUnread
    },
  },
  actions: {
    /**
     * 共通で必要となる（Storeに保存する）マスタをロードします。
     */
    async [LOAD_BASIC_MASTERS]({ commit }, { companyCode, loginId }) {
      // アカウント情報
      const account = await repositories
        .get('account')
        .get(companyCode, loginId)
      commit(SET_ACCOUNT, account)

      // 企業一覧
      const companies = await repositories.get('company').get()
      commit(SET_COMPANIES, companies)
    },
  },
  // https://vuex.vuejs.org/ja/guide/strict.html
  strict: process.env.NODE_ENV === 'development',
})
